import { formatDecimal } from '@shared/lib/format-decimal';

/** USDT summary money with thin spaces: 10 971.9801 $ */
export const formatMoneyRu = (
  value: number | string,
  options?: { signed?: boolean; decimals?: number },
): string => {
  const decimals = options?.decimals ?? 4;
  const formatted = formatDecimal(value, {
    decimals,
    signed: options?.signed,
    trimTrailingZeros: false,
    emptyLabel: formatDecimal('0', { decimals, trimTrailingZeros: false }),
  });

  return `${formatted}\u00a0$`;
};
